import { DevelopmentalData } from "@/types/developmental";

export const age6Activities: DevelopmentalData = {
  motor: [
    "Team sports",
    "Complex crafts",
    "Writing exercises",
    "Musical instruments",
    "Advanced dance activities"
  ],
  language: [
    "Reading comprehension",
    "Creative writing",
    "Public speaking",
    "Vocabulary building",
    "Story analysis"
  ],
  cognitive: [
    "Math word problems",
    "Science experiments",
    "Strategy games",
    "Critical thinking exercises",
    "Research projects"
  ],
  independent: [
    "Schedule management",
    "Project planning",
    "Household responsibilities",
    "Goal setting activities",
    "Self-evaluation exercises"
  ],
  social: [
    "Team leadership",
    "Group discussions",
    "Conflict mediation",
    "Community service",
    "Club participation"
  ]
};